var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category-data-wrapper"},[(!_vm.loading)?_vm._t("default",null,{"category":_vm.category,"categories":_vm.categoryList,"subCategories":_vm.subCategories}):_c('div',{staticClass:"loading"},[_vm._v("Loading...")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }